import Axios from "axios";
import { SETTINGS } from "../../../properties/ApiProps";

export const ProfessionalEventRepository = {
  saveProfessionalEventData: (vacId, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/professionalEvents`,
      method: "POST",
      data: data,
    });
  },
  getProfessionalEventData: (vacId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/professionalEvents`,
      method: "GET",
    });
  },
  getAllTypes: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}professionalEventTypes`,
      method: "GET",
      params: {
        gradingSchemaId: gradingSchemaId,
      },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  getAllRoles: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}professionalEventRoles`,
      method: "GET",
      params: {
        gradingSchemaId: gradingSchemaId,
      },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  updatePoints: (id, points) => {
    return Axios({
      url: `${SETTINGS.API_URL}professionalEvent/${id}/points`,
      params: { points: points },
      method: "PUT",
    });
  },

  unlockPoints: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}professionalEvent/${id}/unlockPoints`,
      method: "PUT",
    });
  },

  setComment: (id, comment) => {
    return Axios({
      url: `${SETTINGS.API_URL}professionalEvent/${id}/comment`,
      params: { comment: comment },
      method: "PUT",
    });
  },
};
